import React from 'react'
import { OverrideComponentProps } from '../utils/overridable-component-helper'

export const DatePickerMonthContext = React.createContext<{ yearMonth: string } | null>(null)

export type DatePickerMonthProps<Tag extends React.ElementType<any> = 'div'> = OverrideComponentProps<Tag> & {
  yearMonth: string
}

export const DatePickerMonth = React.forwardRef<HTMLDivElement, DatePickerMonthProps<any>>(
  ({ yearMonth, as = 'div', ...props }, ref) => {
    return (
      <DatePickerMonthContext.Provider value={{ yearMonth }}>
        {React.createElement(as, { ...props, ref })}
      </DatePickerMonthContext.Provider>
    )
  }
) as WithForwardRefType

DatePickerMonth.displayName = 'DatePickerMonth'

interface WithForwardRefType extends React.FC<DatePickerMonthProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'div'>(props: DatePickerMonthProps<T>): ReturnType<React.FC<DatePickerMonthProps<T>>>
}
